import React, { useEffect, useState } from "react";
import { useAppContext } from "@components/AppContext";

import Page from "@components/Page";
import MyProfile from "@components/MyProfile";
import { type AppContext } from "@components/AppContext/types";

const LABEL_TITLE = "My Profile";

const MyProfilePage = (): JSX.Element => {
  const { identity, updateIdentityMobile, updateIdentityIs2FaEnabled } = useAppContext() as AppContext & {
    updateIdentityMobile?: (mobile: string) => void;
    updateIdentityIs2FaEnabled?: (is2FaEnabled: boolean) => void;
  };

  const givenName = identity?.givenName;
  const familyName = identity?.familyName;
  const email = identity?.email;
  const mobile = identity?.mobile;
  const [ is2FaEnabled, setIs2FaEnabled ] = useState(identity?.is2FaEnabled);

  const fullName = `${givenName || ""} ${familyName || ""}`.trim();
  const onSuccessSwitch2Fa = async (shouldEnable: boolean) => {
    setIs2FaEnabled(shouldEnable);
    updateIdentityIs2FaEnabled?.(shouldEnable);
  };
  const onSuccessUpdateMobile = (updatedMobile: string) => {
    updateIdentityMobile?.(updatedMobile);
  };

  useEffect(() => {
    setIs2FaEnabled(identity?.is2FaEnabled);
  }, [ identity?.is2FaEnabled ]);

  return (
    <Page title={LABEL_TITLE}>
      <MyProfile
        userId={identity?.id || ""}
        name={fullName}
        email={email}
        mobile={mobile}
        is2FaEnabled={is2FaEnabled}
        onSuccessUpdateMobile={onSuccessUpdateMobile}
        onSuccessSwitch2Fa={onSuccessSwitch2Fa}
      />
    </Page>
  );
};

export default MyProfilePage;
